module.exports = __webpack_public_path__ + "static/media/photo4.63627b59.png";